import useSWR from 'swr'

import {
  GetNextActionsVars,
  NextActionsResponse,
  UGCNextActionsApiPath
} from '@/common/api/params/ugcNextActions'

/**
 * ダッシュボードの「今日やるべきこと」。
 *
 * 7観点ぶんの集計が走る（実測 2秒前後）ので、**vars を undefined にしている間は
 * 取得しない**性質を使って遅延読み込みする。呼び出し側はファネル本体の表示が
 * 済んでから vars を渡すこと。
 */
export const useUGCNextActionsApi = (vars: GetNextActionsVars | undefined) => {
  return useSWR<NextActionsResponse, Response, [string, GetNextActionsVars] | undefined>(
    vars ? [UGCNextActionsApiPath.GET_NEXT_ACTIONS, vars] : undefined
  )
}
